  export const eventNames = {
    100: "Quackshot last dart Bullseye!",
    101: "Quackshot Quacktrick",
    102: "Steals the lead",
    103: "Steals the lead, Shanghai",
    104: "Demolition Checkout",
    105: "Final kill",
    106: "Shanghai last dart triple",
    107: "Completes Snakes & Ladders",
    108: "Finishes the Donkey Derby",
    109: "Donkey Derby Bullseye!",
    110: "Donkey last dart triple",
    111: "Limbo Level",
    112: "Winning moment in Limbo"
  };